import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getAuth } from 'firebase/auth';


const firebaseConfig = {

    apiKey: "AIzaSyDQCYwsm5NHzYiAh3eYKAsM6MJtwj0rrpw",
  
    authDomain: "solcializenew.firebaseapp.com",
  
    projectId: "solcializenew",
  
    storageBucket: "solcializenew.firebasestorage.app",
  
    messagingSenderId: "669970186553",
  
    appId: "1:669970186553:web:a6f648bf7da22e0836e8e8",
  
    measurementId: "G-J5EQJ28S8K"
  
  };
  
  // Initialize Firebase
  
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getDatabase(app);
const auth = getAuth(app);

export { app, db, auth };